import { render } from "./ThankYou.vue?vue&type=template&id=82efb6ae&scoped=true&ts=true"
import script from "./ThankYou.vue?vue&type=script&lang=ts"
export * from "./ThankYou.vue?vue&type=script&lang=ts"

import "./ThankYou.vue?vue&type=style&index=0&id=82efb6ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82efb6ae"]])

export default __exports__